const data = [
  {
    id: 1,
    name: "Classe I - Trabalhista",
  },
  {
    id: 2,
    name: "Classe II - Garantia Real",
  },
  {
    id: 3,
    name: "Classe III - Quirografários",
  },
  {
    id: 4,
    name: "Classe IV - ME/EPP",
  },
  {
    id: 5,
    name: "Extraconcursais",
  },
  { 
    id: 6, 
    name: "Ilíquidos"
  },
  { 
    id: 7, 
    name: "Fiscal"
  },
  { 
    id: 8, 
    name: "Não sujeito"
  },
  { 
    id: 9, 
    name: "Não Subordinados"
  }
];

export default [...data];
